import React, { PureComponent } from 'react';
import {
  Breadcrumb,
  BreadcrumbItem,
  Card,
  CardBody,
  CardTitle,
  Container,
  Row,
  Table
} from 'reactstrap';
import { Link } from 'react-router-dom';
import { LinkContainer } from 'react-router-bootstrap';
import cx from 'classnames';

// modules
import BS from '../../theme/Bootstrap';
import Style from '../Containers.module.scss';

// prettier-ignore
const climate = [
  ['', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  ['Record High', '88°', '90°', '91°', '95°', '95°', '98°', '98°', '97°', '99°', '95°', '92°', '89°'],
  ['Average High', '75°', '76°', '79°', '83°', '87°', '90°', '91°', '91°', '90°', '87°', '82°', '77°'],
  ['Average Low', '53°', '54°', '58°', '62°', '67°', '72°', '73°', '73°', '73°', '68°', '62°', '56°'],
  ['Record Low', '26°', '28°', '33°', '39°', '52°', '59°', '62°', '63°', '59°', '46°', '31°', '27°'],
  ['Avg. Precipitation', '2.01 in.', '2.17 in.', '2.08 in.', '1.99 in.', '4.21 in.', '8.18 in.', '7.98 in.', '8.05 in.', '8.11 in.', '3.60 in.', '1.99 in.', '1.53 in.']
];

// prettier-ignore
const census = [
  ['Census, Estimate, & Projections', 'Collier County', 'Florida'],
  ['1980 Census', '85,971', '9,746,961'],
  ['1990 Census', '152,099', '12,938,071'],
  ['2000 Census', '251,377', '15,982,824'],
  ['2010 Census', '321,520', '18,801,332'],
  ['2015 Projection', '363,262', '20,055,865'],
  ['Median Age (2010)', '46.9', '40.7'],
  ['Persons per Square Mile (2010)', '167', '359.2']
];

// prettier-ignore
const transportation = [
  ['Transportation', 'Collier County', 'Florida'],
  ['State Highway Lane Miles', '671.4', '43,337.4'],
  ['State Bridges', '218', '6,702']
];

// prettier-ignore
const land = [
  ['State Lands', 'Collier County', 'Florida'],
  ['Conservation Lands Parcels', '20,896', '378,277'],
  ['Conservation Lands Acreage', '206,265.8', '3,151,774.9'],
  ['Non-Conservation Lands Parcels', '64', '5,859'],
  ['Non-Conservation Lands Acreage', '364.9', '163,209.3']
];

// prettier-ignore
const avg_annual_employment = [
  ['Average Annual Employment % by Category, 2012', 'Collier County', 'Florida'],
  ['All Industries', '12,026', '615,137'],
  ['Natural Resources & Mining', '1.0%', '0.9%'],
  ['Construction', '12.8%', '9.4%'],
  ['Manufacturing', '2.3%', '3.0%'],
  ['Trade, Transportation & Utilities', '18.6%', '22.8%'],
  ['Information', '1.1%', '1.7%'],
  ['Financial Activities', '13.1%', '10.7%'],
  ['Professional & Business Services', '22.7%', '22.6%'],
  ['Education & Health Services', '8.7%', '10.4%'],
  ['Leisure & Hospitality', '8.8%', '8.5%'],
  ['Other Services', '9.9%', '8.6%'],
  ['Government', '0.8%', '1.1%']
];

// prettier-ignore
const avg_annual_wage = [
  ['Average Annual Wage % by Category, 2012', 'Collier County', 'Florida'],
  ['All Industries', '$41,779', '$43,210'],
  ['Natural Resources & Mining', '$22,446', '$27,002'],
  ['Construction', '$39,540', '$41,561'],
  ['Manufacturing', '$50,229', '$53,284'],
  ['Trade, Transportation & Utilities', '$35,835', '$38,621'],
  ['Information', '$59,526', '$66,822'],
  ['Financial Activities', '$71,021', '$61,401'],
  ['Professional & Business Services', '$54,427', '$53,128'],
  ['Education & Health Services', '$49,806', '$45,165'],
  ['Leisure & Hospitality', '$27,470', '$22,304'],
  ['Other Services', '$31,070', '$30,377'],
  ['Government', '$50,085', '$47,898']
];

class Demographics extends PureComponent {
  render() {
    return (
      <Container fluid className={Style.Demographics}>
        <Container>
          <Row>
            <Breadcrumb>
              <LinkContainer exact to="/">
                <BreadcrumbItem>
                  <Link to="/">Home</Link>
                </BreadcrumbItem>
              </LinkContainer>
              <LinkContainer exact to="/about">
                <BreadcrumbItem active>Naples & Collier Demographics</BreadcrumbItem>
              </LinkContainer>
            </Breadcrumb>
          </Row>
        </Container>
        <Container>
          <p>
            Demographic information for Naples and Collier County, Florida, including
            Census, Infrastructure, Employment, and Wages.
          </p>

          <Card className={BS.mb4}>
            <CardBody>
              <CardTitle className={BS.mb0}>Climate</CardTitle>
              <Row>
                <Table className={cx(BS.tableResponsiveLg, Style.climate)}>
                  <thead>
                    <tr>
                      {climate[0].map((val, i) => (
                        <th key={i}>{val}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {climate.slice(1).map((row, i) => (
                      <tr key={i}>
                        {row.map((val, i) => (
                          <td key={i}>{val}</td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </Row>
            </CardBody>
          </Card>

          <Card className={BS.mb4}>
            <CardBody>
              <CardTitle className={BS.mb0}>Population</CardTitle>
              <Row>
                <Table className={cx(BS.tableResponsiveMd)}>
                  <thead>
                    <tr>
                      {census[0].map((val, i) => (
                        <th key={i}>{val}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {census.slice(1).map((row, i) => (
                      <tr key={i}>
                        {row.map((val, i) => (
                          <td key={i}>{val}</td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </Row>
            </CardBody>
          </Card>

          <Card className={BS.mb4}>
            <CardBody>
              <CardTitle className={BS.mb0}>State Infrastructure</CardTitle>
              <Row>
                <Table className={cx(BS.tableResponsiveMd)}>
                  <thead>
                    <tr>
                      {transportation[0].map((val, i) => (
                        <th key={i}>{val}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {transportation.slice(1).map((row, i) => (
                      <tr key={i}>
                        {row.map((val, i) => (
                          <td key={i}>{val}</td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                  <thead>
                    <tr>
                      {land[0].map((val, i) => (
                        <th key={i}>{val}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {land.slice(1).map((row, i) => (
                      <tr key={i}>
                        {row.map((val, i) => (
                          <td key={i}>{val}</td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </Row>
            </CardBody>
          </Card>

          <Card className={BS.mb4}>
            <CardBody>
              <CardTitle className={BS.mb0}>Employment by Industry</CardTitle>
              <Row>
                <Table className={cx(BS.tableResponsiveMd)}>
                  <thead>
                    <tr>
                      {avg_annual_employment[0].map((val, i) => (
                        <th key={i}>{val}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {avg_annual_employment.slice(1).map((row, i) => (
                      <tr key={i}>
                        {row.map((val, i) => (
                          <td key={i}>{val}</td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                  <thead>
                    <tr>
                      {avg_annual_wage[0].map((val, i) => (
                        <th key={i}>{val}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {avg_annual_wage.slice(1).map((row, i) => (
                      <tr key={i}>
                        {row.map((val, i) => (
                          <td key={i}>{val}</td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </Row>
            </CardBody>
          </Card>
          <p>
            <a
              href="http://edr.state.fl.us/content/area-profiles/county/collier.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              Source: Florida Office of Economic and Demographic Research (EDR)
            </a>
          </p>
          <p>
            All information regarding a property for sale, rental or financing, school
            information and public tax records is from sources deemed reliable; PROVIDED,
            HOWEVER, that representations and warranties are not made about the accuracy
            thereof, and such information is subject to errors, omissions, updates,
            modifications, changes of price, rent rates, commissions, prior sales, leases
            or financing, changes in school boundaries, or withdrawal without notice. All
            information displayed on this Website should be independently verified if any
            person intends to engage in a transaction based upon such information.
          </p>
        </Container>
      </Container>
    );
  }
}

export default Demographics;



// WEBPACK FOOTER //
// ./src/containers/Demographics/Demographics.js